import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'app-selection',
    templateUrl: './selection.component.html',
    styleUrls: ['./selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule, NgClass, NgStyle, ControlToKeyNamePipe]
})
export class SelectionComponent {
    public style: Partial<CSSStyleDeclaration>;
    public firstChange = true;

    @ViewChild('label') label: ElementRef<HTMLElement>;
    @Input() control: AbstractControl;
    @Input() value: any;
    @Input() name = '';
    @Input() required = false;
    @Input() checked = false;
    @Input() disabled: boolean = false;

    // Makes the background color scale in as a circle, with center point at the clicked location
    public handleClick(e: MouseEvent): void {
        this.firstChange = false;
        const { clientX, clientY } = e;
        const { nativeElement: label } = this.label;

        if (!this.label) {
            return;
        }

        const diameter = Math.max(label.clientWidth, label.clientHeight);
        const { left, top } = label.getBoundingClientRect();
        let leftPos = `${clientX - left}px`;
        let topPos = `${clientY - top}px`;
        const size = `${diameter}px`;

        if (this.isOutsideOfLabel(leftPos, diameter) || this.isOutsideOfLabel(topPos, diameter)) {
            leftPos = '50%';
            topPos = '50%';
        }

        this.style = {
            width: size,
            height: size,
            left: leftPos,
            top: topPos
        };
    }

    private isOutsideOfLabel(pos: string, max: number): boolean {
        const parsedPos = parseFloat(pos);
        return parsedPos < 0 || parsedPos > max;
    }

    public get formControl(): UntypedFormControl {
        return this.control as UntypedFormControl;
    }
}
